import EventsHelper from '../../_helpers/events';

export default class MatchDataModuleUpdater {
  modules = [];

  constructor() {
    let _this = this;
    _this.loadModulesConfig();

    EventsHelper.On('MatchDataUpdate', function (data) {

      if (data.detail) {
        let filteredModules = _this.modules.filter(e => e.eventName === 'MatchDataUpdate');
        for (const module of filteredModules) {
          _this.updateContent(module);
        }
      }

    });

    EventsHelper.On('PlayerStatsDataUpdate', function (data) {
      if (data.detail) {
        let filteredModules = _this.modules.filter(e => e.eventName === 'PlayerStatsDataUpdate');
        for (const module of filteredModules) {
          _this.updateContent(module);
        }
      }
    });
  }

  loadModulesConfig() {
    let _this = this;

    if (!window.matchconfig) { return; }

    _this.modules.push({
      moduleName: 'MatchStatsByTeam',
      eventName: 'MatchDataUpdate',
      libraryUrl: window.matchconfig.libraries.statsbyteam,
      containerSelector: '.vbw-stats-by-team-wrapper'
    });

    let statsByPlayerChannel = matchconfig.channels.filter(e => e.eventname === 'PlayerStatsDataUpdate');
    if (statsByPlayerChannel?.length) {
      _this.modules.push({
        moduleName: 'MatchStatsByPlayer',
        eventName: 'PlayerStatsDataUpdate',
        libraryUrl: statsByPlayerChannel[0].url,
        containerSelector: '.vbw-stats-by-player-wrapper'
      });
    } else {
      console.warn('No library defined for PlayerStatsDataUpdate');
    }
  }

  updateContent(module) {
    let $setLineupWrapper = $(module.containerSelector);

    if (module.libraryUrl) {
      $setLineupWrapper.load(module.libraryUrl, function () {
        EventsHelper.ContentReload();
      });
    }
  }
}

